/* Mobile gallery Flickity fix
   Problem: product-info's initProductSlider() uses this.querySelector(),
   which only ever grabs the FIRST [data-product-single-media-slider] in the DOM —
   always the desktop one. The mobile gallery (rendered when
   product.metafields.custom.product_mobile_images has values) never gets
   a Flickity instance attached, so its slides/thumbs are static.

   Fix: scope each product-info's slider init to whichever device-group is
   actually visible (CSS display), and give the desktop-only / mobile-only
   wrappers their own independent slider + thumb pair.

   Safari/mobile swipe fix: axis-lock touch handler prevents vertical page
   shake when swiping the carousel horizontally.
*/
(function () {
  function isVisible(el) {
    if (!el) return false;
    return el.offsetParent !== null && getComputedStyle(el).display !== 'none';
  }

  function getActiveGroup(productInfo) {
    var groups = productInfo.querySelectorAll('.product-gallery__device-group');
    if (!groups.length) return null;

    for (var i = 0; i < groups.length; i++) {
      if (isVisible(groups[i])) return groups[i];
    }
    return groups[0];
  }

  // ─── Axis-lock: captures the initial touch angle and surrenders the
  //     event to the browser if the gesture is more vertical than horizontal.
  //     This is what stops the page from shaking on Safari/iOS during swipes.
  // function attachAxisLock(el) {
  //   var startX, startY, axis, flickityStarted;

  //   el.addEventListener('touchstart', function (e) {
  //     var t = e.touches[0];
  //     startX = t.clientX;
  //     startY = t.clientY;
  //     axis = null;
  //     flickityStarted = false;
  //   }, { passive: true });

  //   el.addEventListener('touchmove', function (e) {
  //     var t = e.touches[0];
  //     var dx = Math.abs(t.clientX - startX);
  //     var dy = Math.abs(t.clientY - startY);

  //     var flkty = window.theme && window.theme.Flickity && window.theme.Flickity.data(el);

  //     // If Flickity has started dragging and we haven't locked axis yet,
  //     // suppress the event immediately to stop vertical jitter
  //     if (!axis && flkty && flkty.isPointerDown) {
  //       flickityStarted = true;
  //       if (e.cancelable) e.preventDefault();
  //     }

  //     // Wait for at least 3px of movement before deciding axis
  //     if (dx < 3 && dy < 3) return;

  //     if (!axis) {
  //       axis = dx > dy ? 'horizontal' : 'vertical';

  //       if (axis === 'vertical') {
  //         // Release Flickity's grip so page can scroll naturally
  //         if (flkty && flkty.isPointerDown) {
  //           flkty.pointerUp(e, e.touches[0]);
  //           flkty.isDragging = false;
  //           flkty.isPointerDown = false;
  //           el.classList.remove('is-pointer-down');
  //         }
  //         // Do NOT prevent default — let the page scroll
  //         return;
  //       }
  //     }

  //     if (axis === 'horizontal') {
  //       // Lock the gesture to horizontal — block page scroll
  //       if (e.cancelable) e.preventDefault();
  //     }
  //     // vertical: Flickity released above, page scrolls naturally
  //   }, { passive: false });

  //   el.addEventListener('touchend', function () {
  //     axis = null;
  //     flickityStarted = false;
  //   }, { passive: true });
  // }

  function attachAxisLock(el) {
    var startX, startY, axis;

    el.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      axis = null;
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      var dx = Math.abs(t.clientX - startX);
      var dy = Math.abs(t.clientY - startY);

      if (!axis) {
        // Match Flickity's own dragThreshold so we decide axis at the
        // same moment Flickity decides to start dragging — deciding
        // earlier causes a dead zone (preventDefault with no movement)
        // that ends in a visible snap once Flickity's threshold trips.
        if (dx < 10 && dy < 10) return;

        axis = dx > dy ? 'horizontal' : 'vertical';

        if (axis === 'vertical') {
          var flkty = window.theme && window.theme.Flickity && window.theme.Flickity.data(el);
          if (flkty && flkty.isPointerDown) {
            flkty.pointerUp(e, e.touches[0]); // let Flickity handle its own cleanup
          }
          return; // don't preventDefault — let the page scroll naturally
        }
      }

      if (axis === 'horizontal' && e.cancelable) {
        e.preventDefault();
      }
    }, { passive: false });

    el.addEventListener('touchend', function () {
      axis = null;
    }, { passive: true });
  }

  function initSliderForGroup(productInfo, group) {
    if (!group || group.dataset.flickityBound === 'true') return;

    var slider = group.querySelector('[data-gallery-slider]');
    var thumbs = group.querySelector('[data-gallery-thumbs]');
    var wrappers = group.querySelectorAll('[data-product-single-media-wrapper]');

    if (!slider || !window.theme || !window.theme.Flickity) return;

    if (window.theme.Flickity.data(slider)) return;

    group.dataset.flickityBound = 'true';

    var flkty = null;
    var flktyNav = null;

    if (wrappers.length > 1) {
      flkty = new window.theme.Flickity(slider, {
        wrapAround: true,
        pageDots: true,
        adaptiveHeight: false,
        setGallerySize: false,
        dragThreshold: 10,
        touchAction: 'pan-y',
        on: {
          ready: function () {
            slidesAriaHidden(slider);
            wrappers.forEach(function (w) {
              if (!w.classList.contains('is-selected')) {
                w.querySelectorAll('a, button').forEach(function (el) {
                  el.setAttribute('tabindex', '-1');
                });
              }
            });
          },
          dragStart: function () { slider.classList.add('is-moving'); },
          change: function () { slidesAriaHidden(slider); },
          settle: function (index) {
            var mediaId = flkty.selectedElement.getAttribute('data-media-id');
            flkty.cells.forEach(function (cell, i) {
              cell.element.querySelectorAll('a, button').forEach(function (el) {
                el.setAttribute('tabindex', i === index ? '0' : '-1');
              });
            });
            switchMedia(productInfo, mediaId);
            slider.classList.remove('is-moving');
          }
        }
      });

      // Axis-lock on the slider element itself
      attachAxisLock(slider);

      wrappers.forEach(function (w) {
        w.addEventListener('theme:media:play', function () {
          flkty.options.draggable = false;
          flkty.updateDraggable();
          slider.classList.add('has-media-active');
        });
        w.addEventListener('theme:media:pause', function () {
          flkty.options.draggable = true;
          flkty.updateDraggable();
          slider.classList.remove('has-media-active');
        });
      });

      if (window.theme.flickitySmoothScrolling) {
        window.theme.flickitySmoothScrolling(slider);
      }

      if (thumbs) {
        flktyNav = new window.theme.Flickity(thumbs, {
          asNavFor: slider,
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          resize: true,
          dragThreshold: 10,
          touchAction: 'pan-y',
          on: {
            ready: function () {
              thumbs.setAttribute('tabindex', '-1');
              slidesAriaHidden(thumbs);
            },
            change: function () { slidesAriaHidden(thumbs); }
          }
        });

        attachAxisLock(thumbs);

        if (window.theme.flickitySmoothScrolling) {
          window.theme.flickitySmoothScrolling(thumbs);
        }

        thumbs.querySelectorAll('.product-single__thumbnail, .product-single__thumbnail-link').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var id = btn.getAttribute('data-id');
            if (!id) return;
            var targetIndex = -1;
            wrappers.forEach(function (w, i) {
              if (w.getAttribute('data-id') === id) targetIndex = i;
            });
            if (targetIndex > -1) flkty.select(targetIndex);
          });
        });
      }
    }

    group.__flkty = flkty;
    group.__flktyNav = flktyNav;
  }

  function slidesAriaHidden(el) {
    var instance = window.theme.Flickity.data(el);
    if (!instance) return;
    instance.cells.forEach(function (cell) {
      cell.element.setAttribute('aria-hidden', 'false');
    });
  }

  function switchMedia(productInfo, mediaId) {
    var wrappers = productInfo.querySelectorAll('[data-product-single-media-wrapper]');
    var target = productInfo.querySelector('[data-product-single-media-wrapper][data-media-id="' + mediaId + '"]');
    if (!target) return;

    wrappers.forEach(function (w) {
      w.dispatchEvent(new CustomEvent('theme:media:hidden', { bubbles: true }));
      w.classList.add('media--hidden');
    });

    target.classList.remove('media--hidden');
    target.dispatchEvent(new CustomEvent('theme:media:visible', { bubbles: true }));

    var deferred = target.querySelector('[data-deferred-media]');
    if (deferred && deferred.getAttribute('loaded') !== 'true') {
      var btn = target.querySelector('[data-deferred-media-button]');
      if (btn) btn.dispatchEvent(new Event('click'));
    }
  }

  function initAllGalleries() {
    document.querySelectorAll('product-info').forEach(function (productInfo) {
      var groups = productInfo.querySelectorAll('.product-gallery__device-group');
      if (!groups.length) return;

      var activeGroup = getActiveGroup(productInfo);
      initSliderForGroup(productInfo, activeGroup);
    });
  }

  function reconcileOnResize() {
    document.querySelectorAll('product-info').forEach(function (productInfo) {
      var groups = productInfo.querySelectorAll('.product-gallery__device-group');
      if (!groups.length) return;

      var activeGroup = getActiveGroup(productInfo);
      if (!activeGroup) return;

      if (activeGroup.dataset.flickityBound !== 'true') {
        initSliderForGroup(productInfo, activeGroup);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  document.addEventListener('theme:resize:width', reconcileOnResize);
  window.addEventListener('resize', function () {
    clearTimeout(window.__mobileGalleryResizeTimer);
    window.__mobileGalleryResizeTimer = setTimeout(reconcileOnResize, 200);
  });
})();